module.exports = "/_next/static/images/4cebec632a5a7387fec85ad1f0e8bb6c-floatingCard.svg";